var map = {
	"./interactive.eot": 6,
	"./interactive.svg": 7,
	"./interactive.ttf": 8,
	"./interactive.woff": 9,
	"./interactive.woff2": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;


//////////////////
// WEBPACK FOOTER
// ./src/fonts ^\.\/.*\.*
// module id = 36
// module chunks = 0